import React, { useMemo } from 'react'
import { useInstallationStatus } from '../hooks/use-installation-status'
import InstallationStatusContext from './installation-status-context'

interface Props {
  installationIds: number[]
  children: React.ReactNode
}

export const InstallationStatusProvider: React.FC<Props> = ({ children, installationIds }) => {
  const { data: installationStatuses, isLoading: isStatusLoading } = useInstallationStatus(installationIds)
  const statusMap = useMemo(() => new Map(installationStatuses.map(s => [s.installationId, s])), [installationStatuses])
  const value = useMemo(() => ({ statusMap, isLoading: isStatusLoading }), [statusMap, isStatusLoading])

  return <InstallationStatusContext.Provider value={value}>{children}</InstallationStatusContext.Provider>
}
